<template>
  <div class="blank" :style="'height:' + height + 'px;'"></div>
</template>

<script>
export default {
  props: {
    height: { type: [Number, String], default: 20 },
  },
};
</script>

<style lang="sass" scoped>
.blank
    width: 100%
</style>


// WEBPACK FOOTER //
// src/components/blank.vue